/**
 * 行政管理模块
 * 包含: 业绩统计、KPI设置、目标设置、KPI考核、指标库管理
 */

import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { Tabs, Card } from 'antd';
import {
    BarChartOutlined,
    TeamOutlined,
    AimOutlined,
    AuditOutlined,
    DatabaseOutlined
} from '@ant-design/icons';

import PerformanceStatistics from './components/PerformanceStatistics';
import DeptKPISettings from './components/DeptKPISettings';
import TargetSettings from './components/TargetSettings';
import KPIAssessment from './components/KPIAssessment';
import DimensionLibrary from './components/DimensionLibrary';

import './Administration.css';

const Administration: React.FC = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const [activeTab, setActiveTab] = useState('statistics');

    useEffect(() => {
        const tab = searchParams.get('tab');
        if (tab) {
            setActiveTab(tab);
        }
    }, [searchParams]);

    const handleTabChange = (key: string) => {
        setActiveTab(key);
        setSearchParams({ tab: key });
    };

    const tabItems = [
        {
            key: 'statistics',
            label: (
                <span>
                    <BarChartOutlined />
                    业绩统计
                </span>
            ),
            children: <PerformanceStatistics />,
        },
        {
            key: 'dept-kpi',
            label: (
                <span>
                    <TeamOutlined />
                    部门KPI设置
                </span>
            ),
            children: <DeptKPISettings />,
        },
        {
            key: 'dimension-lib',
            label: (
                <span>
                    <DatabaseOutlined />
                    指标库管理
                </span>
            ),
            children: <DimensionLibrary />,
        },
        {
            key: 'target',
            label: (
                <span>
                    <AimOutlined />
                    目标设置
                </span>
            ),
            children: <TargetSettings />,
        },
        {
            key: 'assessment',
            label: (
                <span>
                    <AuditOutlined />
                    KPI考核
                </span>
            ),
            children: <KPIAssessment />,
        },
    ];

    return (
        <div className="administration-page">
            <Card
                title="行政管理"
                className="administration-card"
                bordered={false}
                bodyStyle={{ padding: '0 24px 24px' }}
            >
                <Tabs
                    activeKey={activeTab}
                    onChange={handleTabChange}
                    items={tabItems}
                    className="administration-tabs"
                    type="line"
                    size="large"
                />
            </Card>
        </div>
    );
};

export default Administration;
